import { api } from "@/domains/shared/services/api";
import { ApiSubscriptionPlan } from "@/domains/subscription/subscriptionPlansApi";

const billingApiUrl = "/billing";

/** Public plan catalog — sole remaining user-scoped billing route. */
export async function billingPlans() {
    const { data } = await api.get<ApiSubscriptionPlan[]>(`${billingApiUrl}/plans`);
    return data;
}
